import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Catalog } from 'modules/Catalog';
import { Cart } from 'modules/Cart';
import { Home } from 'modules/Home';

const Routing = () => (
    <Switch>
        <Route exact path="/" render={Home} />
        <Route exact path="/cart" component={Cart} />
        <Route path="/catalog/:category/:page" component={Catalog} />
        <Route
            path="/catalog/:category"
            component={props => (
                <Redirect to={`/catalog/${props.match.params.category}/1`} />
            )}
        />
        <Route
            path="/catalog"
            component={() => <Redirect to="/catalog/3/1" />}
        />
        <Route component={Home} />
    </Switch>
);

export default Routing;



// WEBPACK FOOTER //
// ./src/modules/Routing/Routing.jsx